import { useEffect } from 'react';

/**
 * Подписи столбцов для таблиц, которые на телефоне превращаются в карточки.
 *
 * В карточке ячейка без подписи бессмысленна: видно «19», но не видно, это
 * остаток, резерв или заказ. Подписи берём из шапки самой таблицы и проставляем
 * атрибутом — так не нужно править разметку каждой таблицы вручную и подписи не
 * разъезжаются с заголовками, когда столбцы меняют.
 */
/**
 * Широкая таблица должна прокручиваться, а не обрезаться.
 *
 * На «Размещении» таблица шире области контента на несколько десятков пикселей —
 * последняя колонка (ячейка и кнопка) просто уезжала под край экрана, и с
 * компьютера её было не достать. Ставим прокрутку родителю там, где таблица
 * реально не помещается; если помещается — ничего не трогаем.
 */
export function ensureTableScroll(root = document) {
  root.querySelectorAll('table').forEach(table => {
    const box = table.parentElement;
    if (!box || box.dataset.tableScroll === 'on') return;
    if (table.scrollWidth > box.clientWidth + 2) {
      box.style.overflowX = 'auto';
      box.style.maxWidth = '100%';
      box.dataset.tableScroll = 'on';
    }
  });
}

export function applyTableLabels(root = document) {
  const tables = root.querySelectorAll('table.table-cards');
  tables.forEach(table => {
    const heads = [...table.querySelectorAll('thead th')].map(th => th.textContent.trim());
    if (!heads.length) return;
    table.querySelectorAll('tbody tr').forEach(tr => {
      [...tr.children].forEach((td, i) => {
        const label = heads[i];
        if (label && td.getAttribute('data-label') !== label) {
          td.setAttribute('data-label', label);
        }
      });
    });
  });
}

/** Держим подписи в актуальном состоянии, пока страница догружает данные. */
export function useTableCards(deps = []) {
  useEffect(() => {
    const narrow = window.innerWidth <= 520;
    const refresh = () => {
      if (narrow) applyTableLabels();   // подписи нужны только в режиме карточек
      ensureTableScroll();              // прокрутка нужна на любой ширине
    };
    refresh();
    let timer = null;
    const observer = new MutationObserver(() => {
      if (timer) return;                       // не чаще двух раз в секунду
      timer = setTimeout(() => { timer = null; refresh(); }, 500);
    });
    observer.observe(document.body, { childList: true, subtree: true });
    return () => { observer.disconnect(); if (timer) clearTimeout(timer); };
  }, deps);
}
